import { render, staticRenderFns } from "./sync.vue?vue&type=template&id=da547ad6&scoped=true&"
import script from "./sync.vue?vue&type=script&lang=js&"
export * from "./sync.vue?vue&type=script&lang=js&"
import style0 from "./sync.vue?vue&type=style&index=0&id=da547ad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da547ad6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da547ad6')) {
      api.createRecord('da547ad6', component.options)
    } else {
      api.reload('da547ad6', component.options)
    }
    module.hot.accept("./sync.vue?vue&type=template&id=da547ad6&scoped=true&", function () {
      api.rerender('da547ad6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clearanceList/components/sync.vue"
export default component.exports